// extracted by mini-css-extract-plugin
export default {"leftcolumn":"ThirdPillarSuccess_leftcolumn__4rnQS","rightcolumn":"ThirdPillarSuccess_rightcolumn__yACn4","columncontent":"ThirdPillarSuccess_columncontent__iUKo+"};